import React from 'react';
import styles from './PopupContainer.module.scss';
import { IconButton } from 'components';
import { icons } from 'assets';

const PopupContainer = ({
  children = null,
  onClose = null,
  title = 'Title',
  size = 'standard'
}) => {
  return (
    <div
      className={styles.overlayContainer}
      onClick={onClose}
    >
      <div
        className={`${styles.popup} ${styles[size]}`}
        onClick={e => e.stopPropagation()}
      >
        <div className={styles.titleContainer}>
          <h3>{title}</h3>
          {size === 'standard' &&
            <IconButton
              icon={icons.closeX}
              className={styles.closeBttn}
              onClick={onClose}
            />}
        </div>
        {children}
      </div>
    </div>
  );
};

export default PopupContainer;
